module.exports = __webpack_public_path__ + "img/logo.e18b88a2.jpeg";